// Module
var code = "<div ng-style=\"{'background-color': $ctrl.color}\"> </div> ";
// Exports
export default code;